import { create } from 'zustand';
import axios from 'axios';
import { useUploadSettingsStore } from './uploadSettingsStore';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const tokenStore = sessionStorage;

export const useAuthStore = create((set, get) => ({
  user: null,
  token: tokenStore.getItem('token'),
  loading: true,

  fetchUser: async () => {
    try {
      const token = get().token;
      if (!token) { set({ loading: false }); return; }
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      const response = await axios.get(`${API}/auth/me`);
      set({ user: response.data, loading: false });
      useUploadSettingsStore.getState().load();
    } catch (err) {
      console.error('Failed to fetch user:', err.message);
      get().logout();
      set({ loading: false });
    }
  },

  login: async (username, password) => {
    const response = await axios.post(`${API}/auth/login`, { username, password });
    const { token, user } = response.data;
    tokenStore.setItem('token', token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    set({ token, user });
    useUploadSettingsStore.getState().load();
    return user;
  },

  logout: () => {
    tokenStore.removeItem('token');
    tokenStore.removeItem('superAdminToken');
    tokenStore.removeItem('superAdminUser');
    tokenStore.removeItem('impersonating');
    delete axios.defaults.headers.common['Authorization'];
    set({ token: null, user: null });
    useUploadSettingsStore.getState().reset();
  },

  changePassword: async (oldPassword, newPassword) => {
    await axios.post(`${API}/auth/change-password`, { oldPassword, newPassword });
  },

  refreshUser: async () => {
    try {
      const response = await axios.get(`${API}/auth/me`);
      set({ user: response.data });
    } catch (err) {
      console.error('Failed to refresh user:', err.message);
    }
  }
}));
